// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1eAmR","requiredAsterisk":"Info_requiredAsterisk__2m-Em"};